import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { durationStringToMinutes, Service } from '@vendasta/meetings';
import { BookMeNowStoreService } from '../book-me-now-store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { NavigationService } from '../navigation.service';

@Component({
  selector: 'app-service-selection-page',
  templateUrl: './service-selection-page.component.html',
  styleUrls: ['./service-selection-page.component.scss'],
  standalone: false,
})
export class ServiceSelectionPageComponent implements OnInit {
  loadingForEnoughTime$: Observable<boolean>;
  service$: Observable<Service | null>;
  hideTitleText$: Observable<boolean>;
  error$ = new BehaviorSubject<string | null>(null);

  constructor(
    public readonly bookMeNowStoreService: BookMeNowStoreService,
    private readonly route: ActivatedRoute,
    private readonly cdr: ChangeDetectorRef,
    private router: Router,
    public navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    const currentPath = this.router.url;
    this.bookMeNowStoreService.storeInitialPath(currentPath);
    const serviceId = this.route.snapshot.params.serviceId;
    const serviceSlug = this.route.snapshot.params.serviceSlug;

    if (serviceId) {
      this.service$ = this.bookMeNowStoreService
        .loadService({
          serviceId,
          serviceSlug,
        })
        .pipe(
          catchError(() => {
            this.bookMeNowStoreService.setErrorDisplay('slug-mismatch-error');
            return of(null);
          })
        );
    } else {
      this.service$ = of(null);
    }

    this.hideTitleText$ = this.route.queryParams.pipe(
      map((params) => params?.hide_header === 'true')
    );
  }

  durationMinutes(duration: string): string {
    const minutes = durationStringToMinutes({ duration });
    return duration === undefined ? '' : `${minutes} minutes`;
  }
}
